import type { LangCode } from '@learnforge/i18n';
import { en } from './en';
import { nl } from './nl';
import { ro } from './ro';
import type { CalcKey } from './keys';

export const locales = {
  en,
  nl,
  ro,
} as const satisfies Partial<Record<LangCode, Record<CalcKey, string>>> & {
  en: Record<CalcKey, string>;
};
export type { CalcKey } from './keys';
